import { render } from "./SummariesCard.vue?vue&type=template&id=52aec152&scoped=true"
import script from "./SummariesCard.vue?vue&type=script&lang=js"
export * from "./SummariesCard.vue?vue&type=script&lang=js"

import "./SummariesCard.vue?vue&type=style&index=0&id=52aec152&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-52aec152"]])

export default __exports__